import { ContentTileItem } from '@helpers/ContentTileItem';

class ContentTiles {
  tiles: HTMLDivElement;

  constructor(tiles: HTMLDivElement) {
    this.tiles = tiles;
    this.init();
  }

  init() {
    const items = this.tiles.querySelectorAll<HTMLElement>('.kf-o-content-tile');
    const hasCarousel = this.tiles.classList.contains('kf-o-content-tiles__carousel');

    items.forEach((item) => new ContentTileItem(item, hasCarousel));
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const tilesContainer = document.querySelectorAll<HTMLDivElement>('.kf-o-content-tiles');

  tilesContainer.forEach((tiles) => new ContentTiles(tiles));
});

export { ContentTiles };
